import axios from "@/util/axios";
export default {
    loadBuildInfo(buildId) {
        return axios.get(`/api/build/${buildId}/get`);
    },
    loadBuildList(pipelineId, page, pageSize) {
        return axios.get(`/api/pipeline/${pipelineId}/buildList`, { params: { page: page, pageSize: pageSize } });
    },
    loadBuildArtifactList(buildId) {
        return axios.get(`/api/build/${buildId}/artifacts`);
    },
    loadBuildTabList(objectId, objectType, currentPage, pageSize) {
        return axios.get(`/api/build/${objectId}/tab/${objectType}`, { params: { currentPage: currentPage, pageSize: pageSize } });
    },
    loadBuildObjectList(buildId, page, pageSize) {
        return axios.get(`/api/build/${buildId}/objects`, { params: { page: page, prepage: pageSize } });
    },
    loadBuildAutoTest(buildId) {
        return axios.get(`/api/build/${buildId}/autotest`);
    },
}